 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"activate~buying-tenders~clients~closed-tender-details~confirm-evaluation-buying-tender~confirm-evalu~3dfe11a7":"activate~buying-tenders~clients~closed-tender-details~confirm-evaluation-buying-tender~confirm-evalu~3dfe11a7","activate":"activate","buying-tenders~clients~create-client~create-tender~document~edit-client~edit-my-tender-offer~edit-te~a2627d60":"buying-tenders~clients~create-client~create-tender~document~edit-client~edit-my-tender-offer~edit-te~a2627d60","buying-tenders~clients~create-client~document~edit-client~home~myTenders~published-buying-tenders~pu~d89a1730":"buying-tenders~clients~create-client~document~edit-client~home~myTenders~published-buying-tenders~pu~d89a1730","buying-tenders~myTenders~selling-tenders":"buying-tenders~myTenders~selling-tenders","buying-tenders":"buying-tenders","myTenders":"myTenders","selling-tenders":"selling-tenders","document":"document","evaluate-buying-tender~evaluate-selling-tender~home":"evaluate-buying-tender~evaluate-selling-tender~home","home":"home","published-buying-tenders":"published-buying-tenders","published-selling-tenders":"published-selling-tenders","clients~create-client~create-tender~create-user~edit-client~edit-my-tender-offer~edit-tender~edit-us~a7cee0c4":"clients~create-client~create-tender~create-user~edit-client~edit-my-tender-offer~edit-tender~edit-us~a7cee0c4","clients":"clients","create-client":"create-client","edit-client":"edit-client","show-client":"show-client","users":"users","closed-tender-details~confirm-evaluation-buying-tender~confirm-evaluation-selling-tender~create-tend~184104b5":"closed-tender-details~confirm-evaluation-buying-tender~confirm-evaluation-selling-tender~create-tend~184104b5","create-tender":"create-tender","edit-my-tender-offer":"edit-my-tender-offer","edit-tender":"edit-tender","make-buying-offer":"make-buying-offer","make-selling-offer":"make-selling-offer","create-user~edit-user~show-user":"create-user~edit-user~show-user","create-user":"create-user","edit-user":"edit-user","show-user":"show-user","closed-tender-details~confirm-evaluation-buying-tender~confirm-evaluation-selling-tender":"closed-tender-details~confirm-evaluation-buying-tender~confirm-evaluation-selling-tender","closed-tender-details":"closed-tender-details","confirm-evaluation-buying-tender~confirm-evaluation-selling-tender~evaluate-buying-tender~evaluate-s~35ac7339":"confirm-evaluation-buying-tender~confirm-evaluation-selling-tender~evaluate-buying-tender~evaluate-s~35ac7339","confirm-evaluation-buying-tender":"confirm-evaluation-buying-tender","confirm-evaluation-selling-tender":"confirm-evaluation-selling-tender","evaluate-buying-tender":"evaluate-buying-tender","evaluate-selling-tender":"evaluate-selling-tender","create-password":"create-password","enable2-fa":"enable2-fa","forgot-password":"forgot-password","login":"login","reset-password":"reset-password","two-factor-auth":"two-factor-auth","commissioner-token":"commissioner-token","no-mobile":"no-mobile","published-tenders":"published-tenders","tenders":"tenders"}[chunkId]||chunkId) + "." + {"activate~buying-tenders~clients~closed-tender-details~confirm-evaluation-buying-tender~confirm-evalu~3dfe11a7":"f0c34226","activate":"fee526a9","buying-tenders~clients~create-client~create-tender~document~edit-client~edit-my-tender-offer~edit-te~a2627d60":"cc4a05e4","buying-tenders~clients~create-client~document~edit-client~home~myTenders~published-buying-tenders~pu~d89a1730":"6d448a66","buying-tenders~myTenders~selling-tenders":"316400fd","buying-tenders":"9587c9e1","myTenders":"e4b67c12","selling-tenders":"6678b34d","document":"2ad9cf0a","evaluate-buying-tender~evaluate-selling-tender~home":"c87cc1db","home":"479e9a8e","published-buying-tenders":"a719363c","published-selling-tenders":"8267d3d2","clients~create-client~create-tender~create-user~edit-client~edit-my-tender-offer~edit-tender~edit-us~a7cee0c4":"2d2544b9","clients":"ec300c43","create-client":"6c1edd37","edit-client":"f38306f8","show-client":"11ad44ca","users":"7f54d05f","closed-tender-details~confirm-evaluation-buying-tender~confirm-evaluation-selling-tender~create-tend~184104b5":"3472c995","create-tender":"d5753d78","edit-my-tender-offer":"c44046fb","edit-tender":"98234317","make-buying-offer":"9554aa9f","make-selling-offer":"72b17490","create-user~edit-user~show-user":"07e4ed1c","create-user":"e5b78a77","edit-user":"e4a291ad","show-user":"5520c783","closed-tender-details~confirm-evaluation-buying-tender~confirm-evaluation-selling-tender":"5c0eef06","closed-tender-details":"c2dac319","confirm-evaluation-buying-tender~confirm-evaluation-selling-tender~evaluate-buying-tender~evaluate-s~35ac7339":"ad434b72","confirm-evaluation-buying-tender":"151011b3","confirm-evaluation-selling-tender":"6c8a4051","evaluate-buying-tender":"95b7ec18","evaluate-selling-tender":"90503c4f","create-password":"e869fd22","enable2-fa":"03a09a1a","forgot-password":"6a1b87df","login":"c01d0560","reset-password":"8a538747","two-factor-auth":"fe8c18ba","commissioner-token":"5d887dbc","no-mobile":"db40dbfc","published-tenders":"5d7799c4","tenders":"3650557f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"activate~buying-tenders~clients~closed-tender-details~confirm-evaluation-buying-tender~confirm-evalu~3dfe11a7":1,"activate":1,"buying-tenders~clients~create-client~create-tender~document~edit-client~edit-my-tender-offer~edit-te~a2627d60":1,"buying-tenders~clients~create-client~document~edit-client~home~myTenders~published-buying-tenders~pu~d89a1730":1,"buying-tenders~myTenders~selling-tenders":1,"buying-tenders":1,"myTenders":1,"selling-tenders":1,"document":1,"home":1,"clients~create-client~create-tender~create-user~edit-client~edit-my-tender-offer~edit-tender~edit-us~a7cee0c4":1,"clients":1,"create-client":1,"edit-client":1,"show-client":1,"users":1,"closed-tender-details~confirm-evaluation-buying-tender~confirm-evaluation-selling-tender~create-tend~184104b5":1,"create-tender":1,"edit-my-tender-offer":1,"edit-tender":1,"make-buying-offer":1,"make-selling-offer":1,"create-user~edit-user~show-user":1,"closed-tender-details~confirm-evaluation-buying-tender~confirm-evaluation-selling-tender":1,"closed-tender-details":1,"confirm-evaluation-buying-tender~confirm-evaluation-selling-tender~evaluate-buying-tender~evaluate-s~35ac7339":1,"confirm-evaluation-buying-tender":1,"confirm-evaluation-selling-tender":1,"evaluate-buying-tender":1,"evaluate-selling-tender":1,"create-password":1,"enable2-fa":1,"forgot-password":1,"login":1,"reset-password":1,"two-factor-auth":1,"commissioner-token":1,"no-mobile":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"activate~buying-tenders~clients~closed-tender-details~confirm-evaluation-buying-tender~confirm-evalu~3dfe11a7":"activate~buying-tenders~clients~closed-tender-details~confirm-evaluation-buying-tender~confirm-evalu~3dfe11a7","activate":"activate","buying-tenders~clients~create-client~create-tender~document~edit-client~edit-my-tender-offer~edit-te~a2627d60":"buying-tenders~clients~create-client~create-tender~document~edit-client~edit-my-tender-offer~edit-te~a2627d60","buying-tenders~clients~create-client~document~edit-client~home~myTenders~published-buying-tenders~pu~d89a1730":"buying-tenders~clients~create-client~document~edit-client~home~myTenders~published-buying-tenders~pu~d89a1730","buying-tenders~myTenders~selling-tenders":"buying-tenders~myTenders~selling-tenders","buying-tenders":"buying-tenders","myTenders":"myTenders","selling-tenders":"selling-tenders","document":"document","evaluate-buying-tender~evaluate-selling-tender~home":"evaluate-buying-tender~evaluate-selling-tender~home","home":"home","published-buying-tenders":"published-buying-tenders","published-selling-tenders":"published-selling-tenders","clients~create-client~create-tender~create-user~edit-client~edit-my-tender-offer~edit-tender~edit-us~a7cee0c4":"clients~create-client~create-tender~create-user~edit-client~edit-my-tender-offer~edit-tender~edit-us~a7cee0c4","clients":"clients","create-client":"create-client","edit-client":"edit-client","show-client":"show-client","users":"users","closed-tender-details~confirm-evaluation-buying-tender~confirm-evaluation-selling-tender~create-tend~184104b5":"closed-tender-details~confirm-evaluation-buying-tender~confirm-evaluation-selling-tender~create-tend~184104b5","create-tender":"create-tender","edit-my-tender-offer":"edit-my-tender-offer","edit-tender":"edit-tender","make-buying-offer":"make-buying-offer","make-selling-offer":"make-selling-offer","create-user~edit-user~show-user":"create-user~edit-user~show-user","create-user":"create-user","edit-user":"edit-user","show-user":"show-user","closed-tender-details~confirm-evaluation-buying-tender~confirm-evaluation-selling-tender":"closed-tender-details~confirm-evaluation-buying-tender~confirm-evaluation-selling-tender","closed-tender-details":"closed-tender-details","confirm-evaluation-buying-tender~confirm-evaluation-selling-tender~evaluate-buying-tender~evaluate-s~35ac7339":"confirm-evaluation-buying-tender~confirm-evaluation-selling-tender~evaluate-buying-tender~evaluate-s~35ac7339","confirm-evaluation-buying-tender":"confirm-evaluation-buying-tender","confirm-evaluation-selling-tender":"confirm-evaluation-selling-tender","evaluate-buying-tender":"evaluate-buying-tender","evaluate-selling-tender":"evaluate-selling-tender","create-password":"create-password","enable2-fa":"enable2-fa","forgot-password":"forgot-password","login":"login","reset-password":"reset-password","two-factor-auth":"two-factor-auth","commissioner-token":"commissioner-token","no-mobile":"no-mobile","published-tenders":"published-tenders","tenders":"tenders"}[chunkId]||chunkId) + "." + {"activate~buying-tenders~clients~closed-tender-details~confirm-evaluation-buying-tender~confirm-evalu~3dfe11a7":"c9f5a90d","activate":"b15a2ef2","buying-tenders~clients~create-client~create-tender~document~edit-client~edit-my-tender-offer~edit-te~a2627d60":"98cbc643","buying-tenders~clients~create-client~document~edit-client~home~myTenders~published-buying-tenders~pu~d89a1730":"d253099c","buying-tenders~myTenders~selling-tenders":"7bbf9e0a","buying-tenders":"17054f6d","myTenders":"2cdb19e9","selling-tenders":"17054f6d","document":"d3cdbbb1","evaluate-buying-tender~evaluate-selling-tender~home":"31d6cfe0","home":"f4aeee07","published-buying-tenders":"31d6cfe0","published-selling-tenders":"31d6cfe0","clients~create-client~create-tender~create-user~edit-client~edit-my-tender-offer~edit-tender~edit-us~a7cee0c4":"cda74012","clients":"547c4348","create-client":"5f55ca95","edit-client":"5f55ca95","show-client":"5f55ca95","users":"f66b99b9","closed-tender-details~confirm-evaluation-buying-tender~confirm-evaluation-selling-tender~create-tend~184104b5":"8c3b68be","create-tender":"b60be9a6","edit-my-tender-offer":"5f7bf5d1","edit-tender":"b60be9a6","make-buying-offer":"87df618b","make-selling-offer":"87df618b","create-user~edit-user~show-user":"c45b0583","create-user":"31d6cfe0","edit-user":"31d6cfe0","show-user":"31d6cfe0","closed-tender-details~confirm-evaluation-buying-tender~confirm-evaluation-selling-tender":"298800cb","closed-tender-details":"566f916d","confirm-evaluation-buying-tender~confirm-evaluation-selling-tender~evaluate-buying-tender~evaluate-s~35ac7339":"a63da596","confirm-evaluation-buying-tender":"8987fd00","confirm-evaluation-selling-tender":"8987fd00","evaluate-buying-tender":"cbce3f19","evaluate-selling-tender":"cbce3f19","create-password":"b15a2ef2","enable2-fa":"b15a2ef2","forgot-password":"b15a2ef2","login":"76005c6f","reset-password":"b15a2ef2","two-factor-auth":"26148522","commissioner-token":"f605df1b","no-mobile":"df9d9a7c","published-tenders":"31d6cfe0","tenders":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
